<template>
  <div class="page">
    <div class="weui-msg">
      <div class="weui-msg__text-area">
        <div class="weui-msg__desc">
          <div class="weui-msg__image-box" :style="fileBoxStyle"></div>
        </div>
        <p class="weui-msg__desc-primary" v-if="!signInfo.signPath">
          还没有签名，请设计您的电子签名
        </p>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <router-link to="/sign/pad" class="weui-btn weui-btn_primary">{{
            signInfo.signPath ? "重新签名" : "设计签名"
          }}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getBaseUrl } from '@/util/env';

let routeParamSignInfo;
export default {
  data: function () {
    return {
      signInfo: {
        signPath: null,
      },
    };
  },
  computed: {
    fileBoxStyle() {
      var url = this.signInfo.signPath;
      if (url) {
        return (
          'background-image: url("' +
          getBaseUrl() +
          "/api/file/download?path=" +
          url +
          '");'
        );
      }
      return "";
    },
  },
  beforeRouteEnter(to, from, next) {
    routeParamSignInfo = from.params.signInfo;
    next();
  },
  mounted() {
    var me = this;
    if (routeParamSignInfo) {
      me.signInfo = routeParamSignInfo;
      routeParamSignInfo = null;
    } else {
      me.loadData();
    }
  },
  methods: {
    loadData() {
      const me = this;
      me.$loading({
        url: "/api/account/sign",
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          me.signInfo = data;
        }
      });
    },
  },
};
</script>

<style scoped>
.weui-msg__image-box {
  width: 80%;
  max-width: 340px;
  height: 105px;
  margin: 0 auto;
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
  border: 1px dashed #d5d5d5;
}
</style>